import React, { createContext, useEffect, useState } from 'react'
import FirstGrassStep from './FirstGrassStep'
import ThirdGrassStep from './ThirdGrassStep'
import {
  StyledButtonGroup,
  StyledButtonOr,
  TabContainer,
  TabContent,
  StyledTabButton
} from './style';
import SecondGrassStep from './SecondStep';
import { CO2OptionsType, WorkOperation } from '~/api/services/co2';
import { useFormContext, useWatch } from 'react-hook-form';

type ContextType = CO2OptionsType & {
  setIsLoadingResults: (value: boolean) => void
  workOperations: WorkOperation[]
  setWorkOperations: (workOperations: WorkOperation[]) => void
}

export const ClimaOptionsContext = createContext<ContextType>(null)

interface Props {
  options: CO2OptionsType
  setIsLoadingResults: (value: boolean) => void
}

const GrassSilageStep: React.FC<Props> = ({ options, setIsLoadingResults }) => {
  const { control } = useFormContext()
  const grassSilageStep = useWatch({ control, name: 'grassSilage.step' })

  const [activeGrassStep, setActiveGrassStep] = useState(0)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const [workOperations, setWorkOperations] = useState<WorkOperation[]>([])

  useEffect(() => {
    handleTabChange(grassSilageStep)
  }, [grassSilageStep])

  function renderSteps() {
    switch (activeGrassStep) {
      case 0:
        return <FirstGrassStep />
      case 1:
        return <SecondGrassStep />
      case 2:
        return <ThirdGrassStep />
      default:
        return <FirstGrassStep />
    }
  }

  const handleTabChange = async (newStep: number) => {
    if (newStep === activeGrassStep) return

    setIsTransitioning(true)

    await new Promise(resolve => setTimeout(resolve, 300))

    setActiveGrassStep(newStep)

    setTimeout(() => setIsTransitioning(false), 200)
  }

  return (
    <ClimaOptionsContext.Provider value={{ ...options, setIsLoadingResults, workOperations, setWorkOperations }}>
      <TabContainer>
        <StyledButtonGroup widths={'3'} size={'large'}>
          <StyledTabButton
            className={activeGrassStep === 0 ? 'active-step' : ''}
            type={'button'}
            content={'Ernte und Ertrag'}
            disabled={isTransitioning}
          />
          <StyledButtonOr text='>>' />
          <StyledTabButton
            className={activeGrassStep === 1 ? 'active-step' : ''}
            type={'button'}
            content={'Düngung'}
            disabled={isTransitioning}
          />
          <StyledButtonOr text='>>' />
          <StyledTabButton
            className={activeGrassStep === 2 ? 'active-step' : ''}
            type={'button'}
            content={'Bewirtschaftung'}
            disabled={isTransitioning}
          />
        </StyledButtonGroup>

        <TabContent
          isTransitioning={isTransitioning}
          activeStep={activeGrassStep}
        >
          {!isTransitioning && renderSteps()}
        </TabContent>
      </TabContainer>
    </ClimaOptionsContext.Provider>
  )
}

export default GrassSilageStep